<template>
  <el-row>
    <el-col :span="24">
      <el-card>
        <div slot="header" class="flex justify-between">
          <span>添加员工</span>
        </div>
        <div class="content">
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="photo-section">
                <video id="staffPhoto" style="width: 100%;"></video>
                <canvas id="canvas" style="display:none;"></canvas>
                <div class="photo-actions">
                  <el-button 
                    type="primary" 
                    @click="_takePhoto()"
                    icon="el-icon-camera"
                  >拍照</el-button>
                  <el-upload
                    action=""
                    :auto-upload="false"
                    :show-file-list="false"
                    :on-change="_choosePhoto"
                  >
                    <el-button type="default">上传照片</el-button>
                  </el-upload>
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <el-form label-width="120px">
                <el-form-item label="员工名称(2-10位)">
                  <el-input 
                    v-model="addStaffViewInfo.username" 
                    placeholder="必填，请填写员工名称（2-10位）"
                  ></el-input>
                </el-form-item>
                <el-form-item label="员工性别">
                  <el-select 
                    v-model="addStaffViewInfo.sex" 
                    placeholder="必填，请选择员工性别"
                    style="width:100%"
                  >
                    <el-option 
                      label="请选择员工性别" 
                      value="" 
                      disabled
                    ></el-option>
                    <el-option label="男" value="0"></el-option>
                    <el-option label="女" value="1"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="员工岗位">
                  <el-select 
                    v-model="addStaffViewInfo.relCd" 
                    placeholder="必填，请选择岗位"
                    style="width:100%"
                  >
                    <el-option 
                      label="请选择岗位" 
                      value="" 
                      disabled
                    ></el-option>
                    <el-option 
                      v-for="(item,index) in addStaffViewInfo.relCds" 
                      :key="index"
                      :label="item.name" 
                      :value="item.statusCd"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="员工邮箱">
                  <el-input 
                    v-model="addStaffViewInfo.email" 
                    placeholder="可选，请填写员工邮箱"
                  ></el-input>
                </el-form-item>
                <el-form-item label="手机">
                  <el-input 
                    v-model="addStaffViewInfo.tel" 
                    placeholder="必填，请填写手机"
                    maxlength="11"
                  ></el-input>
                </el-form-item>
                <el-form-item label="家庭住址">
                  <el-input 
                    v-model="addStaffViewInfo.address" 
                    placeholder="必填，请填写家庭住址"
                  ></el-input>
                </el-form-item>
                <el-form-item label="照片">
                  <img 
                    width="150" 
                    height="150" 
                    :src="addStaffViewInfo.photo" 
                    alt="员工照片"
                  >
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'

export default {
  name: 'AddStaffView',
  props: {
    callBackListener: String,
    callBackFunction: String
  },
  data() {
    return {
      addStaffViewInfo: {
        flowComponent: 'addStaffView',
        username: '',
        sex: '',
        email: '',
        tel: '',
        address: '',
        relCd: '',
        relCds: [],
        videoPlaying: false,
        photo: '/img/defaultAvatar.png'
      },
      mediaStream: null
    }
  },
  watch: {
    addStaffViewInfo: {
      deep: true,
      handler() {
        this.saveAddStaffInfo()
      }
    }
  },
  created() {
    this.getDictData()
  },
  methods: {
    async getDictData() {
      try {
      const {data} = await getDict('u_org_staff_rel', 'rel_cd')
        this.addStaffViewInfo.relCds = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    updateIndex(index) {
      console.log(index)
      this.addStaffViewInfo.index = index
      if (index === 2) {
        this.$nextTick(() => {
          this._initAddStaffMedia()
        })
      } else if (this.mediaStream) {
        this._stopMediaStream()
      }
    },
    saveAddStaffInfo() {
      if (this.addStaffValidate()) {
        this.$emit(this.callBackFunction, this.addStaffViewInfo)
      }
    },
    addStaffValidate() {
      // 这里可以添加表单验证逻辑
      return true
    },
    _addUserMedia() {
      return navigator.getUserMedia || 
             navigator.webkitGetUserMedia ||
             navigator.mozGetUserMedia ||
             navigator.msGetUserMedia || null
    },
    _initAddStaffMedia() {
      if (this._addUserMedia()) {
        this.addStaffViewInfo.videoPlaying = false
        const constraints = {
          video: true,
          audio: false
        }
        const video = document.getElementById('staffPhoto')
        
        navigator.mediaDevices.getUserMedia(constraints)
          .then(stream => {
            this.mediaStream = stream
            try {
              video.srcObject = stream
              video.play()
              this.addStaffViewInfo.videoPlaying = true
            } catch (error) {
              console.error('初始化视频失败:', error)
            }
          })
          .catch(error => {
            console.error('获取媒体设备失败:', error)
          })
      }
    },
    _takePhoto() {
      if (this.addStaffViewInfo.videoPlaying) {
        const canvas = document.getElementById('canvas')
        const video = document.getElementById('staffPhoto')
        canvas.width = video.videoWidth
        canvas.height = video.videoHeight
        canvas.getContext('2d').drawImage(video, 0, 0)
        const data = canvas.toDataURL('image/jpeg', 1.0)
        this.addStaffViewInfo.photo = data
      }
    },
    _choosePhoto(file) {
      if (file.size > 1024 * 1024 * 2) {
        this.$message.error('图片大小不能超过 2MB!')
        return false
      }
      const reader = new FileReader()
      reader.readAsDataURL(file.raw)
      reader.onloadend = (e) => {
        console.log(e)
        this.addStaffViewInfo.photo = reader.result
      }
    },
    _stopMediaStream() {
      if (this.mediaStream) {
        this.mediaStream.getTracks().forEach(track => track.stop())
        this.mediaStream = null
        const video = document.getElementById('staffPhoto')
        video.srcObject = null
        this.addStaffViewInfo.videoPlaying = false
      }
    }
  },
  beforeDestroy() {
    this._stopMediaStream()
  }
}
</script>

<style scoped>
.photo-section {
  text-align: center;
}
.photo-actions {
  margin-top: 20px;
}
.photo-actions .el-button {
  margin: 0 5px;
}
</style>